import React, { ReactElement, useEffect, useState } from 'react';
import './Winners.scss';
import _ from 'lodash';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import WinnersTitle from '../../assets/images/voitjad.png';

interface PrizeList {
  sup: Pick<any, string | number | symbol>[];
}

const Winners: React.FC = (): ReactElement => {
  const { t } = useTranslation();

  const [winners, setWinners] = useState<PrizeList>({
    sup: [],
  });

  const getWinners = async () => {
    const res = await axios.get('/api/dataservice/winners/');

    // console.log(res);
    const prizes = _.mapValues(_.groupBy(res.data, 'prize'), (plist) =>
      plist.map((prize) => _.omit(prize, 'prize')),
    );

    setWinners({
      sup: prizes.sup === undefined ? [] : prizes.sup,
    });
  };

  useEffect(() => {
    getWinners();
  }, []);

  return (
    <div className="winners">
      {/* <h2>{t('winners')}</h2> */}
      <div className="title-wrapper">
        <img src={WinnersTitle} alt="" className="title-image" />
      </div>
      <div className="winners-wrapper columns">
        <div className="column">
          <ul className={winners.sup.length === 0 ? 'hidden' : ''}>
            {/* <li className="prize-name">SUP Laud</li> */}
            {winners.sup.map(function (item: any, index: any) {
              return (
                <li key={index}>{item.first_name + ' ' + item.last_name}</li>
              );
            })}
            {/* <li>name name</li> */}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Winners;
